export default __webpack_public_path__ + "static/media/Helm of Clarity.dcee85ad.jpg";